<template>
	<div
		class="mx-1 dropdown inline-block relative"
		:class="{ open: is_open }"
	>
		<button
			class="bg-gray-300 text-gray-700 py-2 px-4 rounded inline-flex items-center"
			@click="dropdown_click"
		>
			<span class="mr-1">{{ title }}</span>
			<svg
				class="fill-current h-4 w-4"
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 20 20"
			>
				<path
					d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
				/>
			</svg>
		</button>
		<ul class="dropdown-menu absolute hidden text-gray-700 pt-1">
			<li class="">
				<span
					class="rounded-t bg-gray-200 hover:bg-gray-400 py-2 px-4 block whitespace-no-wrap"
					>One</span
				>
			</li>
			<li class="">
				<span
					class="bg-gray-200 hover:bg-gray-400 py-2 px-4 block whitespace-no-wrap"
					>Two</span
				>
			</li>
			<li class="">
				<span
					class="rounded-b bg-gray-200 hover:bg-gray-400 py-2 px-4 block whitespace-no-wrap"
					>Three is the magic number</span
				>
			</li>
		</ul>
	</div>
</template>

<style lang="scss" scoped>
.dropdown.open .dropdown-menu {
	display: block;
}
</style>

<script>
export default {
	data() {
		return {
			is_open: false,
		};
	},
	props: {
		title: String,
	},
	methods: {
		dropdown_click() {
			this.is_open = !this.is_open;
		},
	},
};
</script>
